<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'repeat-pattern.establish-pattern-title'">_Patrón de repeticion
    </span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content common-modal__content-scroll">
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <span class="establish-pattern__subtitle-container"
        [afTranslate]="'repeat-pattern.task-frecuency'">_Periodicidad de la tarea</span>
      <field-type-list-simple
        class="establish-pattern__periodicity-list"
        [field]="establishPatternModal.periodicityType"
        [preSelectItem]="establishPatternModal.periodicityTypeSelected?.listValueId"
        [listValues]="establishPatternModal.patternList.periodicityList"
        (itemSelected)="selectFrecuency($event.newValue)">
      </field-type-list-simple>
      @if (establishPatternModal.periodicityTypeSelected?.listValueId) {
        <div class="common-radio-button-list__container-box">
          <div class="common-text-input__block-header">
            <p class="common-text-input__label">
              <span class="common-text-input__text-label"
                [afTranslate]="'repeat-pattern.end-interval'">
              </span>
              <span class="common-tag__mandatory-text-asterisk">*</span>
            </p>
          </div>
          @switch (establishPatternModal.periodicityTypeSelected?.listValueId) {
            @case (1) {
              <label for="daily-first-option"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="daily-first-option"
                  class="common-radio-button__no-input"
                  type="radio"
                  name="daily-options"
                  value="1"
                  [(ngModel)]="establishPatternModal.radioOptionDaily">
                  <div class="common-radio-button__size-sm">
                    <i class="common-icon__sm"
                      [ngClass]="establishPatternModal.radioOptionDaily === '1'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                    </i>
                  </div>
                  <span class="common-radio-button-list__switch-option-text capitalize"
                    [afTranslate]="'add-alert.every'">_Cada</span>
                  <input-number [preSelectValue]="establishPatternModal.dailyEachDay"
                    (selectedValue)="setNumber('dailyEachDay', $event)"
                    [disabled]="establishPatternModal.radioOptionDaily !== '1'">
                  </input-number>
                  <span class="common-radio-button-list__switch-option-text"
                    [afTranslate]="'repeat-pattern.days'">_día(s)</span>
              </label>
              <label for="daily-second-option"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="daily-second-option"
                  class="common-radio-button__no-input"
                  type="radio"
                  name="daily-options"
                  value="2"
                  [(ngModel)]="establishPatternModal.radioOptionDaily">
                  <div class="common-radio-button__size-sm">
                    <i class="common-icon__sm"
                      [ngClass]="establishPatternModal.radioOptionDaily === '2'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                    </i>
                  </div>
                  <span class="common-radio-button-list__switch-option-text"
                    [afTranslate]="'repeat-pattern.all-days-week'">_Todos los días de la semana</span>
              </label>
            }
            @case (2) {
              <label for="weekly-first-option"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="weekly-first-option"
                  class="common-radio-button__no-input"
                  type="radio"
                  name="weekly-options"
                  value="1"
                  [(ngModel)]="establishPatternModal.radioOptionWeekly">
                  <div class="common-radio-button__size-sm">
                    <i class="common-icon__sm"
                      [ngClass]="establishPatternModal.radioOptionWeekly === '1'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                    </i>
                  </div>
                  <span class="common-radio-button-list__switch-option-text"
                    [afTranslate]="'repeat-pattern.repeat-every'">_Repetir cada</span>
                  <input-number [preSelectValue]="establishPatternModal.weeklyEachWeek"
                    (selectedValue)="setNumber('weeklyEachWeek', $event)"
                    [disabled]="establishPatternModal.radioOptionWeekly !== '1'">
                  </input-number>
                  <span class="common-radio-button-list__switch-option-text"
                    [afTranslate]="'repeat-pattern.weeks-in-days'"></span>
                  <ul class="common-date__weekdays-block">
                    @for (dayWeek of establishPatternModal.patternList.weekDays; track $index) {
                      <li class="common-date__weekdays-group">
                        <button class="common-date__weekdays-day capitalize"
                          [ngClass]="{'common-date__weekdays-day--active': dayWeek.selected}"
                          (click)="addOrDeleteWeekDay(dayWeek)">
                          {{dayWeek.text}}
                        </button>
                        @if(!$last){
                          <div class="common-divider__vertical-grey-400 h-[14px]"></div>
                        }
                      </li>
                    }
                  </ul>
              </label>
            }
            @case (3) {
              <label for="monthly-first-option"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="monthly-first-option"
                  class="common-radio-button__no-input"
                  type="radio"
                  name="monthly-options"
                  value="1"
                  [(ngModel)]="establishPatternModal.radioOptionMonthly">
                <div class="common-radio-button__size-sm">
                  <i class="common-icon__sm"
                    [ngClass]="establishPatternModal.radioOptionMonthly === '1'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                  </i>
                </div>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.the-day'">_El dia</span>
                <input-number [preSelectValue]="establishPatternModal.monthlyEachDay"
                  (selectedValue)="setNumber('monthlyEachDay', $event)"
                  [disabled]="establishPatternModal.radioOptionMonthly !== '1'"
                  [from]="1"
                  [until]="31">
                </input-number>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.kind'">_de cada</span>
                <input-number [preSelectValue]="establishPatternModal.monthlyEachMonth"
                  (selectedValue)="setNumber('monthlyEachMonth', $event)"
                  [disabled]="establishPatternModal.radioOptionMonthly !== '1'">
                </input-number>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.month'">mes</span>
              </label>
              <label for="monthly-second-option"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="monthly-second-option"
                  class="common-radio-button__no-input"
                  name="monthly-options"
                  value="2"
                  [(ngModel)]="establishPatternModal.radioOptionMonthly">
                <div class="common-radio-button__size-sm">
                  <i class="common-icon__sm"
                    [ngClass]="establishPatternModal.radioOptionMonthly === '2'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                  </i>
                </div>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.the'">_El</span>
                <button-with-text-menu-arrow
                  [item]="establishPatternModal.buttonMonthlyNumeral"
                  [list]="establishPatternModal.patternList.numeralTimeList"
                  [selectedOption]="establishPatternModal.monthlyNumeralSelected"
                  (launchActionEmitter)="selectOptionSelectSimple('monthlyNumeralSelected', $event)"
                  [disabled]="establishPatternModal.radioOptionMonthly !== '2'">
                </button-with-text-menu-arrow>
                <button-with-text-menu-arrow
                  [item]="establishPatternModal.buttonMonthlyWeekday"
                  [list]="establishPatternModal.patternList.weekDayList"
                  [selectedOption]="establishPatternModal.monthlyWeekdaySelected"
                  (launchActionEmitter)="selectOptionSelectSimple('monthlyWeekdaySelected', $event)"
                  [disabled]="establishPatternModal.radioOptionMonthly !== '2'">
                </button-with-text-menu-arrow>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.kind'">_de cada</span>
                <input-number [preSelectValue]="establishPatternModal.monthlyEachMonth"
                  (selectedValue)="setNumber('monthlyEachMonth', $event)"
                  [disabled]="establishPatternModal.radioOptionMonthly !== '2'">
                </input-number>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.month'">mes</span>
              </label>
            }
            @case (4) {
              <label for="annual-first-option"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="annual-first-option"
                  class="common-radio-button__no-input"
                  type="radio"
                  name="annual-options"
                  value="1"
                  [(ngModel)]="establishPatternModal.radioOptionAnnual">
                <div class="common-radio-button__size-sm">
                  <i class="common-icon__sm"
                    [ngClass]="establishPatternModal.radioOptionAnnual === '1'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                  </i>
                </div>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.the-day'">_El dia</span>
                <input-number [preSelectValue]="establishPatternModal.annualEachDay"
                  (selectedValue)="setNumber('annualEachDay', $event)"
                  [disabled]="establishPatternModal.radioOptionAnnual !== '1'"
                  [from]="1"
                  [until]="31">
                </input-number>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.kind'">_de cada</span>
                <button-with-text-menu-arrow
                  [item]="establishPatternModal.buttonAnnualMonth"
                  [list]="establishPatternModal.patternList.monthList"
                  [selectedOption]="establishPatternModal.annualMonthSelected"
                  (launchActionEmitter)="selectOptionSelectSimple('annualMonthSelected', $event)"
                  [disabled]="establishPatternModal.radioOptionAnnual !== '1'">
                </button-with-text-menu-arrow>
              </label>
              <label for="annual-second-option"
                class="common-radio-button-list__switch-option-container">
                <input type="radio"
                  id="annual-second-option"
                  class="common-radio-button__no-input"
                  type="radio"
                  name="annual-options"
                  value="2"
                  [(ngModel)]="establishPatternModal.radioOptionAnnual">
                <div class="common-radio-button__size-sm">
                  <i class="common-icon__sm"
                    [ngClass]="establishPatternModal.radioOptionAnnual === '2'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                  </i>
                </div>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.the'">_El</span>
                <button-with-text-menu-arrow
                  [item]="establishPatternModal.buttonAnnualMonth"
                  [list]="establishPatternModal.patternList.numeralTimeList"
                  [selectedOption]="establishPatternModal.annualNumeralSelected"
                  (launchActionEmitter)="selectOptionSelectSimple('annualNumeralSelected', $event)"
                  [disabled]="establishPatternModal.radioOptionAnnual !== '2'">
                </button-with-text-menu-arrow>
                <button-with-text-menu-arrow
                  [item]="establishPatternModal.buttonAnnualWeekday"
                  [list]="establishPatternModal.patternList.weekDayList"
                  [selectedOption]="establishPatternModal.annualWeekdaySelected"
                  (launchActionEmitter)="selectOptionSelectSimple('annualWeekdaySelected', $event)"
                  [disabled]="establishPatternModal.radioOptionAnnual !== '2'">
                </button-with-text-menu-arrow>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.kind'">_de cada</span>
                <button-with-text-menu-arrow
                  [item]="establishPatternModal.buttonAnnualMonth"
                  [list]="establishPatternModal.patternList.monthList"
                  [selectedOption]="establishPatternModal.annualMonthSelectedSecond"
                  (launchActionEmitter)="selectOptionSelectSimple('annualMonthSelectedSecond', $event)"
                  [disabled]="establishPatternModal.radioOptionAnnual !== '2'">
                </button-with-text-menu-arrow>
              </label>
            }
          }
        </div>
      }
      <span class="establish-pattern__subtitle-container"
        [afTranslate]="'repeat-pattern.repeat-interval'">_Intervalo de repetición</span>
      <field-type-date class="establish-pattern__periodicity-list"
        [field]="establishPatternModal.repeatIntervalDate"
        [preSelectItem]="establishPatternModal.startInterval"
        (itemSelected)="selectIntervalDate($event, 'startInterval')">
      </field-type-date>
      @if (establishPatternModal.periodicityTypeSelected?.listValueId) {
        <div class="common-radio-button-list__container">
          <div class="common-radio-button-list__container-box"
            [ngClass]="{'common-radio-button-list__container-box--error': establishPatternModal.selectIntervalError}">
            <div class="common-text-input__block-header">
              <p class="common-text-input__label">
                <span class="common-text-input__text-label"
                  [afTranslate]="'repeat-pattern.end-interval'">
                </span>
                <span class="common-tag__mandatory-text-asterisk">*</span>
              </p>
            </div>
            <label for="no-end-date"
              class="common-radio-button-list__switch-option-container">
              <input type="radio"
                class="common-radio-button__no-input"
                id="no-end-date"
                name="select-interval"
                value="no-end-date"
                [(ngModel)]="establishPatternModal.selectInterval"
                (change)="changeInterval()">
                <div class="common-radio-button__size-sm">
                  <i class="common-icon__sm"
                    [ngClass]="establishPatternModal.selectInterval === 'no-end-date'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                  </i>
                </div>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'repeat-pattern.no-end-date'">_Sin fecha de finalización</span>
            </label>
            <label for="finish-after"
              class="common-radio-button-list__switch-option-container">
              <input type="radio"
                id="finish-after"
                class="common-radio-button__no-input"
                type="radio"
                name="no-end-date"
                value="finish-after"
                [(ngModel)]="establishPatternModal.selectInterval"
                (change)="changeInterval()">
              <div class="common-radio-button__size-sm">
                <i class="common-icon__sm"
                  [ngClass]="establishPatternModal.selectInterval === 'finish-after'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                </i>
              </div>
              <span class="common-radio-button-list__switch-option-text"
                [afTranslate]="'repeat-pattern.finish-after'">_Finalizar después de</span>
              <input-number
                [preSelectValue]="establishPatternModal.amountRepetitionsInterval"
                (selectedValue)="setNumber('amountRepetitionsInterval', $event)"
                [disabled]="establishPatternModal.selectInterval !== 'finish-after'">
              </input-number>
              <span class="common-radio-button-list__switch-option-text"
                [afTranslate]="'repeat-pattern.repetitions'">_repeticiones</span>
            </label>
            <label for="end-interval-day"
              class="common-radio-button-list__switch-option-container">
              <input type="radio"
                id="end-interval-day"
                class="common-radio-button__no-input"
                type="radio"
                name="no-end-date"
                value="end-interval-day"
                [(ngModel)]="establishPatternModal.selectInterval"
                (change)="changeInterval()">
              <div class="common-radio-button__size-sm">
                <i class="common-icon__sm"
                  [ngClass]="establishPatternModal.selectInterval === 'end-interval-day'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                </i>
              </div>
              <span class="common-radio-button-list__switch-option-text"
                [afTranslate]="'repeat-pattern.end-interval-day'">_Finalizar el intervalo el día</span>
              <picker-data-simple
                [item]="establishPatternModal.finishIntervalItem"
                [finishIntervalDate]="establishPatternModal.finishIntervalDate"
                (selectDate)="selectIntervalDate($event, 'finishIntervalDate')"
                [disabled]="establishPatternModal.selectInterval !== 'end-interval-day'">
              </picker-data-simple>
            </label>
          </div>
          @if(establishPatternModal.selectIntervalError){
            <div class="common-text-input__mandatory-tag">
              <span [afTranslate]="'expiration-period.error-null-date'">_Es necesario seleccionar una fecha</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
  @if(establishPatternModal.modifyPattern){
    <advice-message [type]="'warning'"
      [text]="establishPatternModal.infoText"
      (closeAdvice)="closeAdvice('modifyPattern')">
    </advice-message>
  }
  <div class="common-modal__footer">
    @if (establishPatternModal.repeatPattern && establishPatternModal.repeatPattern.frecuencyId) {
      <button class="common-button__text-noborder"
        (click)="handleDismiss('delete')">
        <span class="common-button__text-title"
          [afTranslate]="'establish-pattern-modal.delete-repetition'">_Eliminar repetición
        </span>
      </button>
    }
    <button class="common-button__text-border"
      (click)="handleDismiss('cancel')">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar
      </span>
    </button>
    <button class="common-button__text"
      (click)="validateRepetition()">
      <span class="common-button__text-title"
        [afTranslate]="'common.add'">_Añadir
      </span>
    </button>
  </div>
</div>
